<template>
  <Layout title="Welcome to CHI Au Pair">
    <LoginForm v-on:form-submitted="submitData" />
    <PageLoading v-if="loading" />
  </Layout>
</template>

<script>
import LoginForm from "@/components/Forms/LoginForm.vue";
import Layout from "@/Layout/NotAuthenticated/Layout.vue";

export default {
  name: "Login",
  data() {
    return {
      user: null,
      loading: false,
    };
  },
  components: {
    Layout,
    LoginForm,
  },
  methods: {
    submitData(user) {
      this.user = user;
      this.loading = true;
      this.$store
        .dispatch("logUserIn", this.user)
        .then(() => {
          this.$store
            .dispatch("getUser")
            .then(() => {
              this.loading = false;
              if (this.$store.state.user.role === "HostFamily") {
                this.$router.push("/");
              } else {
                this.$toasted.global.notificate({
                  message: "Invalid user name or password",
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.global.notificate({
            message: error.response.data,
            type: "error",
          });
        });
    },
  },
};
</script>
